/* @generated */
const THEME_CLASSES = {
  vis2020: {
    baseSelector: ":root, .dig-Theme",
    baseClassName: "dig-Theme",
    modes: {
      bright: {
        selector: ":root, .dig-Theme--bright",
        className: "dig-Theme--bright",
        classList: "dig-Theme dig-Theme--bright dig-Mode--bright",
        genericModeClassName: "dig-Mode--bright",
        genericModeSelector: ".dig-Mode--bright"
      },
      dark: {
        selector: ".dig-Theme--dark",
        className: "dig-Theme--dark",
        classList: "dig-Theme dig-Theme--dark dig-Mode--dark",
        genericModeClassName: "dig-Mode--dark",
        genericModeSelector: ".dig-Mode--dark"
      }
    }
  },
  vis2023: {
    baseSelector: ".dig-Theme-vis2023",
    baseClassName: "dig-Theme-vis2023",
    modes: {
      bright: {
        selector: ".dig-Theme-vis2023--bright",
        className: "dig-Theme-vis2023--bright",
        classList: "dig-Theme-vis2023 dig-Theme-vis2023--bright dig-Mode--bright",
        genericModeClassName: "dig-Mode--bright",
        genericModeSelector: ".dig-Mode--bright"
      },
      dark: {
        selector: ".dig-Theme-vis2023--dark",
        className: "dig-Theme-vis2023--dark",
        classList: "dig-Theme-vis2023 dig-Theme-vis2023--dark dig-Mode--dark",
        genericModeClassName: "dig-Mode--dark",
        genericModeSelector: ".dig-Mode--dark"
      }
    }
  }
};
const DEFAULT_THEME = {
  theme: "vis2020",
  mode: "bright"
};
const GENERIC_THEME_CLASSNAME = "In-Theme-Provider";
const GENERIC_DARK_MODE_CLASSNAME = "dig-Mode--dark";
export {
  DEFAULT_THEME,
  GENERIC_DARK_MODE_CLASSNAME,
  GENERIC_THEME_CLASSNAME,
  THEME_CLASSES
};
